import React, {useEffect, useState} from 'react';
import {
    CButton, CButtonGroup, CCard, CCardBody, CCardFooter, CCardText, CCardTitle,
    CCol,
    CContainer,
    CFormCheck,
    CFormFloating,
    CFormInput,
    CFormLabel, CFormTextarea,
    CInputGroup,
    CInputGroupText,
    CRow
} from "@coreui/react";
import {useSelector} from "react-redux";
import store from "../../storeWire";
import {toServer, destroyFromServer, updateField} from "../../store/slice/customerLedger";
import {usePage} from "@inertiajs/inertia-react";
import * as CustomerAccountCommon from "../CustomerAccount/common";
import axios from "axios";
import Helper from "../../application/helper";
import {setData} from "../../store/slice/customerAccount";

const Common = (props) => {
    const p = usePage();
    const [action, setAction] = useState('edit');
    const [readOnly, setReadonly] = useState(false);
    const [initial, setInitial] = useState(false);
    const [customer_account_number, set_customer_account_number] = useState('');
    const d = useSelector((state) => state.entities.customerLedger)
    const onInputHandle = (event, name) => {
        store.dispatch(updateField({
            field_name: name,
            value: event.target.value,
        }));
    }
    useEffect(() => {
        if (p.props.customer_ledger) {
            setAction('edit');
        }
        if (p.props.current_route_name === 'customer-ledger.delete') {
            setAction('delete');
        }
        if (props.action !== undefined) {
            setAction(props.action);
        }
        if (p.props.action !== undefined) {
            setAction(p.props.action);
        }
    }, []);
    useEffect(() => {
        if (action === 'delete' || action === 'approve' || action === 'reject') {
            setReadonly(true);
        }
        if (initial === false) {
            setCustomerAccountData();
        }
    });
    const submitForm = () => {
        store.dispatch(toServer());
    }
    const approveForm = async ()  => {
        await store.dispatch(updateField({
            field_name: 'approve_action',
            value: 'auto',
        }));
        await store.dispatch(toServer());
    }
    const rejectForm = () => {
        store.dispatch(updateField({
            field_name: 'reject_action',
            value: 'auto',
        }));
        store.dispatch(toServer());
    }
    const setCustomerAccountData = () => {
        if (d.customer_account !== undefined &&
            d.customer_account.customer_account_number !== undefined) {
            setInitial(true);
            getCustomerAccountNumber(d.customer_account.customer_account_number);
            set_customer_account_number(d.customer_account.customer_account_number);
        }
    }
    const destroyForm = () => {
        store.dispatch(destroyFromServer());
    }
    const getCustomerAccountNumber = (customer_account_number) => {
        if (customer_account_number && (
            customer_account_number.length > 8 &&
            customer_account_number.length < 15
        )) {
            axios.get(Helper.route('customeraccount.show', {
                customeraccount: customer_account_number
            })).then((res) => {
                if (res.data.data.id !== undefined && res.data.data.id) {
                    store.dispatch(setData(res.data.data));
                    store.dispatch(updateField({
                        field_name: 'customer_account_id',
                        value: res.data.data.id,
                    }));
                } else {
                    store.dispatch(setData({}));
                    store.dispatch(updateField({
                        field_name: 'customer_account_id',
                        value: '',
                    }));
                }
            }).catch(() => {
                store.dispatch(setData({}));
                store.dispatch(updateField({
                    field_name: 'customer_account_id',
                    value: '',
                }));
            });
        }
    }
    const backToHome = () => {
        window.history.back();
    }
    return <>
        <CContainer fluid={true}>
            <CRow>
                <CCard>
                    <CCardBody>
                        <CCardTitle>Ledger</CCardTitle>
                        <CCardText>
                            Basic Information Regarding Customer which will be used for Ledger Keeping and more.
                        </CCardText>
                        <CRow>
                            <CCol>
                                <CFormFloating className="mb-3">
                                    <CFormInput type="text"
                                                onChange={(e) => {
                                                    onInputHandle(e, 'amount')
                                                }}
                                                defaultValue={d['amount'] || ""}
                                                disabled={readOnly} readOnly={readOnly}
                                    />
                                    <CFormLabel htmlFor="floatingInput">Amount</CFormLabel>
                                </CFormFloating>
                            </CCol>
                            <CCol>
                                <CFormLabel htmlFor="basic-url">Transaction Type</CFormLabel>
                                <CFormFloating>
                                    <CFormCheck inline type="radio" name="transaction_type" value="deposit"
                                                label="Deposit"
                                                onChange={(e) => {
                                                    onInputHandle(e, 'transaction_type')
                                                }}
                                                disabled={readOnly} readOnly={readOnly}
                                                defaultChecked={(d['transaction_type'] && d['transaction_type'] === 'deposit')}
                                    />
                                    <CFormCheck inline type="radio" name="transaction_type" value="withdrawal"
                                                label="Withdrawal"
                                                onChange={(e) => {
                                                    onInputHandle(e, 'transaction_type')
                                                }}
                                                disabled={readOnly} readOnly={readOnly}
                                                defaultChecked={(d['transaction_type'] && d['transaction_type'] === 'withdrawal')}
                                    />
                                </CFormFloating>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CFormFloating className="mb-3">
                                    <CInputGroup>
                                        <CInputGroupText>Note</CInputGroupText>
                                        <CFormTextarea aria-label="With textarea"
                                                       onChange={(e) => {
                                                           onInputHandle(e, 'note')
                                                       }}
                                                       disabled={readOnly} readOnly={readOnly}
                                                       defaultValue={d['note'] || ""}/>
                                    </CInputGroup>
                                </CFormFloating>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                <CFormFloating className="mb-3">
                                    <CInputGroup>
                                        <CInputGroupText>Search: Customer Account Number</CInputGroupText>
                                        <CFormTextarea aria-label="With textarea"
                                                       onChange={(e) => {
                                                           getCustomerAccountNumber(e.target.value, 'note')
                                                       }}
                                                       disabled={readOnly} readOnly={readOnly}
                                                       defaultValue={customer_account_number || ""}/>
                                        <CInputGroupText>Check Below Result</CInputGroupText>
                                    </CInputGroup>
                                </CFormFloating>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                        <CRow>
                            <CCol>
                                <CButtonGroup role="group" aria-label="Basic mixed styles example">
                                    {action === 'edit' &&
                                    <CButton size="lg"
                                             onClick={() => {
                                                 submitForm();
                                             }}
                                             component="input" type="submit" color="primary" value="Submit"/>
                                    }
                                    {action === 'approve' &&
                                    <CButton size="lg"
                                             onClick={() => {
                                                 approveForm();
                                             }}
                                             component="input" type="submit" color="success" value="Approve"/>
                                    }
                                    {action === 'reject' &&
                                    <CButton size="lg"
                                             onClick={() => {
                                                 rejectForm();
                                             }}
                                             component="input" type="submit" color="danger" value="Reject"/>
                                    }
                                    {action === 'search' &&
                                    <CButton size="lg"
                                             onClick={() => {
                                                 props.onSearch(d);
                                             }}
                                             component="input" type="submit" color="primary" value="Search"/>
                                    }
                                    {action !== 'search' &&
                                    <CButton size="lg"
                                             onClick={() => {
                                                 backToHome();
                                             }}
                                             component="input" type="submit" color="secondary" value="Back"/>
                                    }
                                </CButtonGroup>
                            </CCol>

                            {d.id !== undefined && action === 'delete' &&
                            <CCol>
                                <CButton size="lg"
                                         onClick={() => {
                                             destroyForm();
                                         }}
                                         component="input" type="submit" color="danger" value="Destroy"
                                         className={'float-end'}
                                />
                            </CCol>
                            }
                        </CRow>
                    </CCardFooter>
                </CCard>
            </CRow>
        </CContainer>
        <CustomerAccountCommon.default
            action={'search'}
            readOnly={true}
        />
    </>
        ;
}
export default Common;
